import Settings from '@/models/settings'

// initial state
const state = {
  loaded: false,
  general: null,
  modules: null
}

// getters
const getters = { }

// mutations
const mutations = {
  setFromAPI: (state: any, value: any) => {
    const settings = new Settings(value)

    state.general = settings.general
    state.modules = settings.modules

    state.loaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
